/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';
import Radio from 'backbone.radio';
import Syphon from 'backbone.syphon';
import Backbone from 'backbone';
import RadioTriggerBehavior from 'psa-marionette/behaviors/RadioTriggerBehavior';

import Session from '@/Session';
import showModal from '@/util/showModal';
import lazyLoadView from '@/util/lazyLoadView';

import CommandDetailsView from '../../views/CommandDetailsView';
import loadPOCGridView from '../../loaders/POCGridViewLoader';
import loadDraftOrdersGridView from '../../loaders/DraftOrdersGridViewLoader';
import loadInProgressOrdersGridView from '../../loaders/InProgressOrdersGridViewLoader';
import loadInProgressAssesmentsGridView from '../../loaders/InProgressAssessmentsGridViewLoader';
import loadPOCDetailsModalView from '../../loaders/POCDetailsModalViewLoader';

import './ExtDashboardPage.css';

import tmplExtDashboardPage from './ExtDashboardPage.hbs';

const ExtDashboardPage = View.extend({
  template: tmplExtDashboardPage,

  className: 'ext-dashboard-page',

  ui: {
    commandSelect: '.command-select',
    commandDetailsView: '#commandDetailsView',
    pointsOfContactGridContainer: '#pointsOfContactGridContainer',
    draftOrdersGridContainer: '#draftOrdersGridContainer',
    inProgressOrdersGridContainer: '#inProgressOrdersGridContainer',
    inProgressAssessmentsGridContainer: '#inProgressAssessmentsGridContainer'
  },

  regions: {
    commandDetailsView: '@ui.commandDetailsView',
    pointsOfContactGridContainer: '@ui.pointsOfContactGridContainer',
    draftOrdersGridContainer: '@ui.draftOrdersGridContainer',
    inProgressOrdersGridContainer: '@ui.inProgressOrdersGridContainer',
    inProgressAssessmentsGridContainer: '@ui.inProgressAssessmentsGridContainer'
  },

  events: {
    'change @ui.commandSelect': 'changeCommand',
    'click .add-poc': 'addPOC'
  },

  behaviors: {
    RadioTriggerBehavior: {
      behaviorClass: RadioTriggerBehavior
    }
  },

  changeCommand(e) {
    e.preventDefault();
    const commandID = this.ui.commandSelect.val();
    Session.user.actingAsCommandId = commandID;
    Session.user.commandName = this.model.get('commands').find((command) => command.id === commandID).name;
    Radio.channel('navigate').request('show:ext:dashboard', commandID);
  },

  toggleForm(state) {
    this.$el.find(':input').prop('disabled', !state);
  },

  onRender() {
    Syphon.deserialize(this, { commandID: this.model.get('command').id });

    this.showChildView(
      'commandDetailsView',
      new CommandDetailsView({
        model: new Backbone.Model(this.model.get('command'))
      })
    );

    this.showChildView(
      'pointsOfContactGridContainer',
      lazyLoadView(() => loadPOCGridView(this.model.get('command').id, 'ext'))
    );
    this.showChildView(
      'draftOrdersGridContainer',
      lazyLoadView(() => loadDraftOrdersGridView(this.model.get('command').id))
    );
    this.showChildView(
      'inProgressOrdersGridContainer',
      lazyLoadView(() => loadInProgressOrdersGridView(this.model.get('command').id))
    );
    this.showChildView(
      'inProgressAssessmentsGridContainer',
      lazyLoadView(() => loadInProgressAssesmentsGridView(this.model.get('command').id))
    );
  },

  addPOC(e) {
    e.preventDefault();
    showModal({
      title: 'Add Point of Contact',
      dialogClasses: 'modal-lg',
      view: lazyLoadView(() => loadPOCDetailsModalView(this.model.get('command').id, null, true))
    }).then((formData) => {
      if (formData) {
        formData.name = `${formData.firstName} ${formData.lastName}`;
        this.getChildView('pointsOfContactGridContainer')
          .getChildView('viewContainer')
          .options.collection.unshift(formData);
      }
    });
  },

});

export default ExtDashboardPage;
